export const LAKSHMIKANT_DASHBOARD_EMAIL = 'lakshmikant@kasgidhaneshwari.online';

export const isLakshmikantDashboardUser = (email) =>
  (email || '').toString().trim().toLowerCase() === LAKSHMIKANT_DASHBOARD_EMAIL;
